<div class="flex flex-col font-roboto font-medium text-input text-text-base items-start">
    @if (label) {
    <label class="mb-xs px-input_label_padding bg-input-label-background top-input_label_offset_y bg-input- left-input_label_offset_x relative z-10" [id]="labelId" [for]="inputId">
        <span apxLabel>
            {{ label }}
        </span>
    </label>
    }

    <ng-content apxInput></ng-content>

    @if (errorMessage || hint) {
    <div class="flex mt-xs px-xs">
        @if (errorMessage) {
        <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="hintTemplate"></ng-container>
        }
    </div>
    }
</div>

<ng-template #errorTemplate>
    <div class="flex items-center justify-center text-error">
        <span porIcon [icon]="icon" class="flex items-center mr-xs w-xs max-h-xs" color="red"></span>
        <p class="p-none m-none">{{ errorMessage }}</p>
    </div>
</ng-template>

<ng-template #hintTemplate>
    <p class="p-none m-none">{{ hint }}</p>
</ng-template>
